// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"9ea1a2f2","211":"42777576","216":"be3f65a1","447":"de9dd1b5","485":"53ba089c","886":"46a5505b","900":"45312557"}[chunkId] + ".chunk.js";
};